const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

const twoDigitsToWords = (value) => {
  const number = Number(value || 0);
  if (number < 20) return ones[number];
  return [tens[Math.floor(number / 10)], ones[number % 10]].filter(Boolean).join(" ");
};

const threeDigitsToWords = (value) => {
  const number = Number(value || 0);
  const hundred = Math.floor(number / 100);
  const remainder = number % 100;
  return [
    hundred ? `${ones[hundred]} Hundred` : "",
    remainder ? twoDigitsToWords(remainder) : "",
  ].filter(Boolean).join(" ");
};

export const numberToIndianWords = (value) => {
  let number = Math.floor(Math.abs(Number(value || 0)));
  if (!Number.isFinite(number)) return "";
  if (number === 0) return "Zero";

  const parts = [];
  const crore = Math.floor(number / 10000000);
  number %= 10000000;
  const lakh = Math.floor(number / 100000);
  number %= 100000;
  const thousand = Math.floor(number / 1000);
  number %= 1000;

  if (crore) parts.push(`${threeDigitsToWords(crore)} Crore`);
  if (lakh) parts.push(`${threeDigitsToWords(lakh)} Lakh`);
  if (thousand) parts.push(`${threeDigitsToWords(thousand)} Thousand`);
  if (number) parts.push(threeDigitsToWords(number));

  return parts.join(" ");
};

export const amountToIndianWords = (amount) => {
  const numericAmount = Number(String(amount ?? "").replace(/[^0-9.-]/g, ""));
  if (!Number.isFinite(numericAmount)) return "";

  const absoluteAmount = Math.abs(numericAmount);
  const rupees = Math.floor(absoluteAmount);
  const paise = Math.round((absoluteAmount - rupees) * 100);
  const rupeeWords = numberToIndianWords(rupees);
  const paiseWords = paise ? numberToIndianWords(paise) : "";

  if (paiseWords) {
    return `${rupeeWords} Rupees and ${paiseWords} Paise Only`;
  }

  return `${rupeeWords} Rupees Only`;
};
